import { PLAN_NAMES } from 'constant';

export function getPlanNameData(planId) {
    planId = planId.toString();
    if (planId.length < 4) {
        return;
    }
    const planType = parseInt(planId[0].concat(planId[1]));
    const planDuration = parseInt(planId[2].concat(planId[3]));
    const planTypeId = PLAN_NAMES[planType];
    if (!planTypeId) {
        return;
    }

    return { duration: planDuration, id: planTypeId };
}
